module.exports = __webpack_public_path__ + "static/media/sb_symbol.a2c2b3ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/images/sb_symbol.png
// module id = 445
// module chunks = 0